import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../../config';
import type { SandboxAction } from './useSandboxActions';

export function useTemplateActions(templateId: string | null) {
  return useQuery({
    queryKey: ['template-actions', templateId],
    queryFn: async (): Promise<SandboxAction[]> => {
      const res = await fetch(
        `${API_URL}/org/environments/templates/${templateId}/actions`,
        { credentials: 'include' }
      );
      if (!res.ok) throw new Error('Failed to load template actions');
      const json = (await res.json()) as { ok: boolean; data: SandboxAction[] };
      return json.data;
    },
    enabled: !!templateId,
  });
}
